import React, {Component} from 'react'

// import styles
import './privacypolicymodal.scss'

// import components
import Modal from '../../components/Modal'

// Elements
import Col from '../../elements/col'
import Icon from '../../elements/icon'
import { GeneralIcons } from '../../elements/icons'

// Utils
import { translation } from '../../../utils/helpers'

class PrivacyPolicyModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false
    }
  }

  getPolicyText () {
    return {
      __html: translation(16654)
    }
  }

  render () {
    return (
      <div className='privacypolicy__modal'>
        <Modal {...this.props} header={translation('16653')}>
          <Icon icon={GeneralIcons.Print} className='non-printable' size='s' onClick={() => window.print()} />
          <Col span='4'>
            <div className='text' dangerouslySetInnerHTML={this.getPolicyText()} />
          </Col>
        </Modal>
      </div>
    )
  }

}

export default PrivacyPolicyModal



// WEBPACK FOOTER //
// ./src/app/shared/modals/PrivacyPolicyModal/index.js